import { render } from "./get-more-info.vue?vue&type=template&id=d2757614"
import script from "./get-more-info.vue?vue&type=script&lang=js"
export * from "./get-more-info.vue?vue&type=script&lang=js"

import "./get-more-info.vue?vue&type=style&index=0&id=d2757614&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-detail-info/fashion/get-more-info.vue'],['render',render],['__file',"get-more-info.vue"]])

export default __exports__